
import * as THREE from "../../libs/three.js/build/three.module.js";

export class ElevationZone extends THREE.Object3D {

	constructor(camera) {
		super();

		this.constructor.counter = (this.constructor.counter === undefined) ? 0 : this.constructor.counter + 1;
		this.name = "elevation_zone_" + this.constructor.counter;

		this.camera = camera.clone();
		this.camera.rotation.set(...camera.rotation.toArray());
		this.camera.rotation.order = camera.rotation.order;
		this.camera.updateMatrixWorld();
		this.camera.updateProjectionMatrix();
		this.camera.matrixWorldInverse.copy(this.camera.matrixWorld).invert();

		this.viewMatrix = this.camera.matrixWorldInverse.clone();
		this.projMatrix = this.camera.projectionMatrix.clone();

		// NDC positions of polygon vertices
		this.markers = [];
		this.initialized = false;

		// Z range computed from points inside the polygon
		this.zRange = { min: Infinity, max: -Infinity };
		this.zFences = { low: -Infinity, high: Infinity };
		this.zRangeComputed = false;
	}

	addMarker() {
		let marker = new THREE.Mesh();
		this.markers.push(marker);
		return marker;
	}

	removeLastMarker() {
		if (this.markers.length > 0) {
			this.markers.splice(this.markers.length - 1, 1);
		}
	}
}
